import React from "react";
import "./header.css";
import CTA from "./CTA";
import HeaderLinks from "./HeaderLinks";
import ME_ABOUT from "../../assets/me-about.png"; // Import your updated about photo
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Nazib Hasan</h1>
        <h5 className="text-light">Fullstack Developer</h5>
        <CTA />
        <HeaderLinks />

        {/* REPLACED OLD .me IMAGE WITH THE COMBINED ABOUT LAYOUT */}
        <div className="header__about-content">
          <div className="about__me">
            <div className="about__me-image">
              <img src={ME_ABOUT} alt="Nazib Hasan profile avatar" />
            </div>
          </div>

          <div className="about__text-content">
            <div className="about__cards">
              <article className="about__card">
                <FaAward className="about__icon" />
                <h5>Experience</h5>
                <small>2+ Years Working</small>
              </article>
              <article className="about__card">
                <FiUsers className="about__icon" />
                <h5>Clients</h5>
                <small>Lots in future</small>
              </article>
              <article className="about__card">
                <VscFolderLibrary className="about__icon" />
                <h5>Projects</h5>
                <small>10+ Completed Projects</small>
              </article>
            </div>

            <p>
              I am a full stack developer. My mission is to create beautiful websites 
              and innovate seamless user experiences using different tools. Passionate 
              about technologies and always checking out new games. I thrive on 
              collaboration and turning bold ideas into tangible success. Let’s build 
              something impactful.
            </p>
          </div>
        </div>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;